<template>
  <div id="event-personal-slashie">
  <PsEventHeader></PsEventHeader>
  <PsEventMain></PsEventMain>
  <PsEventTA></PsEventTA>
  <PsEventProduct></PsEventProduct>
  <PsEventPricing></PsEventPricing>
  <PsEventApply></PsEventApply>
  <PsEventFaq></PsEventFaq>
  <PsEventFooter></PsEventFooter>
  <PsEventModal></PsEventModal>
  </div>
</template>

<script>

import PsEventMain from "@/components/event-personal-slashie/PsEventMain.vue"
import PsEventHeader from "@/components/event-personal-slashie/PsEventHeader.vue"
import PsEventFooter from "@/components/event-personal-slashie/PsEventFooter.vue"
import PsEventProduct from "@/components/event-personal-slashie/PsEventProduct.vue"
import PsEventTA from "@/components/event-personal-slashie/PsEventTA.vue"
import PsEventPricing from "@/components/event-personal-slashie/PsEventPricing.vue"
import PsEventApply from "@/components/event-personal-slashie/PsEventApply.vue"
import PsEventFaq from "@/components/event-personal-slashie/PsEventFaq.vue"
import PsEventModal from "@/components/event-personal-slashie/PsEventModal.vue"

  export default {
    name: 'Slashie',
    metaInfo: {
    title: '免月租、零負擔、隨時開張，，讓收入更靈活。陪你一起斜槓的收款工具！',
    titleTemplate: 'INSTO Tap | %s ',
  },
    components: {
      PsEventMain,
      PsEventHeader,
      PsEventFooter,
      PsEventProduct,
      PsEventApply,
      PsEventTA,
      PsEventPricing,
      PsEventFaq,
      PsEventModal
    }
}
</script>

<style lang="scss" scoped>

  @import "@/assets/sass/main.scss";
  @import "@/assets/sass/personal-slashie.scss";

  #event-personal-slashie {
    margin-left: 0;
    cursor: default;
    position: relative;
  }

  .router-view-layout {
    width: 100%;
  }

  .show {
  display: block;
}
</style>
